/**
 * Values the API sends as `demographicsSource` (insights, YouTube channels) and
 * as `{ig,tt,yt}BenchmarksSource` (benchmarks) when the data did not come from
 * a connected account.
 */
export const DEMOGRAPHICS_SOURCES = {
  /** Modash estimate for a non-connected account. Gated by `foam_modash_audience_demographics`. */
  modashEstimated: 'estimated-metrics',
  /** TikTok's official public audience data for a non-connected account. */
  tiktokPublic: 'tiktok-pipelines-public',
} as const;
